import { render, staticRenderFns } from "./HeaderWidgetSupport.vue?vue&type=template&id=7c450f54&"
import script from "./HeaderWidgetSupport.vue?vue&type=script&lang=js&"
export * from "./HeaderWidgetSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports